export default __webpack_public_path__ + "f80f12bc2ba0428eb767fda369a2a464.png";